// export const FETCH_BRANCH_REQUEST = "FETCH_BRANCH_REQUEST";
// export const FETCH_BRANCH_SUCCESS = "FETCH_BRANCH_SUCCESS";
// export const FETCH_BRANCH_FAILURE = "FETCH_BRANCH_FAILURE";

export const FETCH_BRANCH_REQUEST = "FETCH_BRANCH_REQUEST";
export const FETCH_BRANCH_SUCCESS = "FETCH_BRANCH_SUCCESS";
export const FETCH_BRANCH_FAILURE = "FETCH_BRANCH_FAILURE";

export const CREATE_BRANCH_REQUEST = "CREATE_BRANCH_REQUEST";
export const CREATE_BRANCH_SUCCESS = "CREATE_BRANCH_SUCCESS";
export const CREATE_BRANCH_FAILURE = "CREATE_BRANCH_FAILURE";

export const UPDATE_BRANCH_REQUEST = "UPDATE_BRANCH_REQUEST";
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS";
export const UPDATE_BRANCH_FAILURE = "UPDATE_BRANCH_FAILURE";

export const DELETE_BRANCH_REQUEST = "DELETE_BRANCH_REQUEST";
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAILURE = "DELETE_BRANCH_FAILURE";
